/**
 *  NHS Layout icon definement
 *  @author Tony Blacker, NHS Leadership Academy
 *  @version 1.0 6th February 2020
 */

export const onecolsIcon = wp.element.createElement('svg',
    {
        width: 60,
        height: 30
    },
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "0.000",
            width: "59.000",
            height: "30"
        }
    ),
);
export const twocolsIcon = wp.element.createElement('svg',
    {
        width: 60,
        height: 30
    },
    wp.element.createElement( 'rect',
        {
            x: "31.000",
            y: "0.000",
            width: "29.000",
            height: "30"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "0.000",
            width: "29.000",
            height: "30"
        }
    ),
);
export const threecolsIcon = wp.element.createElement('svg',
    {
        width: 60,
        height: 30
    },
    wp.element.createElement( 'rect',
        {
            x: "41.000",
            y: "0.000",
            width: "19.000",
            height: "30"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "21.000",
            y: "0.000",
            width: "19.000",
            height: "30"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "0.000",
            width: "19.000",
            height: "30"
        }
    ),
);

export const threetwocolstworowsIcon = wp.element.createElement('svg',
    {
        width: 60,
        height: 40
    },
    wp.element.createElement( 'rect',
        {
            x: "41.000",
            y: "0.000",
            width: "19.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "21.000",
            y: "0.000",
            width: "19.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "0.000",
            width: "19.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "31.000",
            y: "20.000",
            width: "29.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "20.000",
            width: "29.000",
            height: "19"
        }
    ),
);
export const threecolstworowsIcon = wp.element.createElement('svg',
    {
        width: 60,
        height: 40
    },
    wp.element.createElement( 'rect',
        {
            x: "41.000",
            y: "0.000",
            width: "19.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "21.000",
            y: "0.000",
            width: "19.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "0.000",
            width: "19.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "41.000",
            y: "20.000",
            width: "19.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "21.000",
            y: "20.000",
            width: "19.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "20.000",
            width: "19.000",
            height: "19"
        }
    ),
);

export const twothreecolstworowsIcon = wp.element.createElement('svg',
    {
        width: 60,
        height: 40
    },
    wp.element.createElement( 'rect',
        {
            x: "31.000",
            y: "0.000",
            width: "29.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "0.000",
            width: "29.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "41.000",
            y: "20.000",
            width: "19.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "21.000",
            y: "20.000",
            width: "19.000",
            height: "19"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "20.000",
            width: "19.000",
            height: "19"
        }
    ),
);

export const twoleftthirdIcon = wp.element.createElement('svg',
    {
        width: 60,
        height: 30
    },
    wp.element.createElement( 'rect',
        {
            x: "21.000",
            y: "0.000",
            width: "39.000",
            height: "30"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "0.000",
            width: "19.000",
            height: "30"
        }
    ),
);
export const tworightthirdIcon = wp.element.createElement('svg',
    {
        width: 60,
        height: 30
    },
    wp.element.createElement( 'rect',
        {
            x: "41.000",
            y: "0.000",
            width: "19.000",
            height: "30"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "0.000",
            width: "39.000",
            height: "30"
        }
    )
);
export const twofourfourIcon = wp.element.createElement('svg',
    {
        width: 60,
        height: 30
    },
    wp.element.createElement( 'rect',
        {
            x: "46.000",
            y: "0.000",
            width: "14.000",
            height: "30"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "31.000",
            y: "0.000",
            width: "14.000",
            height: "30"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "0.000",
            width: "29.000",
            height: "30"
        }
    ),
);

export const fourtwofourIcon = wp.element.createElement('svg',
    {
        width: 60,
        height: 30
    },
    wp.element.createElement( 'rect',
        {
            x: "46.000",
            y: "0.000",
            width: "14.000",
            height: "30"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "16.000",
            y: "0.000",
            width: "29.000",
            height: "30"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "0.000",
            width: "14.000",
            height: "30"
        }
    ),
);

export const fourfourtwoIcon = wp.element.createElement('svg',
    {
        width: 60,
        height: 30
    },
    wp.element.createElement( 'rect',
        {
            x: "31.000",
            y: "0.000",
            width: "29.000",
            height: "30"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "16.000",
            y: "0.000",
            width: "14.000",
            height: "30"
        }
    ),
    wp.element.createElement( 'rect',
        {
            x: "0.000",
            y: "0.000",
            width: "14.000",
            height: "30"
        }
    ),
);
